//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import is from 'is_js'

import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import Sidebar from '../components/sidebars/Sidebar'
import LoginAside from '../components/sidebars/Login'
import FeedbackAside from '../components/sidebars/Feedback'
import ProfileAside from '../components/sidebars/Profile'
import MenuAside from '../components/sidebars/Menu'
import NotificationsAside from '../components/sidebars/Notifications'
import Patron from '~/components/forms/Patron'
import BecomePatron from "~/components/forms/BecomePatron";
import PatronImage from "~/components/forms/PatronImage";
import { PortalTarget } from 'portal-vue'
import Cookie from '~/components/other/Cookie'
import Boarding from '~/components/boarding/Boarding'
import MtCursor from '@/components/other/cursor/MtCursor'
import ErrorBoundary from '@/components/other/ErrorBoundary'
import { formatDate } from '~/utils/utils';
import MtModalFull from '@/components/Modal/MtModalFull'
import Registration from '@/components/forms/Registration'
import DonationModal from '@/components/forms/DonationModal'
import GiftedPatron from '@/components/forms/GiftedPatron'
import CancelPatron from '@/components/forms/CancelPatron'
import MtModal from '@/components/Modal/MtModal'
import ButtonToTop from '@/components/other/ButtonToTop.vue'

export default {
  scrollToTop: true,
  components: {
    ErrorBoundary,
    MtCursor,
    MtModal,
    CancelPatron,
    GiftedPatron,
    DonationModal,
    Registration,
    MtModalFull,
    Boarding,
    Cookie,
    Header,
    Footer,
    Sidebar,
    LoginAside,
    ProfileAside,
    MenuAside,
    NotificationsAside,
    FeedbackAside,
    PortalTarget,
    Patron,
    BecomePatron,
    PatronImage,
    ButtonToTop
  },
  provide () {
    return {
      $isMobile: () => this.isMobile,
      $activeBlocks: () => this.activeBlocks,
      $activeCommonBlocks: () => this.activeCommonBlocks,
    }
  },
  data() {
    return {
      openRegistration: false,
      openMirNextMounth: false,
      masterpieceForPatron: null,
      masterpieceForReturnPatron: null,
      myProfileData: null,
      showOnBoarding: !this.$cookies.get('token') && this.$cookies.get('boardingShown') !== true && this.$router.currentRoute.path.indexOf('/oauth') < 0,
      cookieVisible: false,
      isTouchDevice: is.touchDevice(),
      windowWidth: null,
      smSize: 600
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    activeBlocks () {
      return this.getActiveBlocks?.data?.data?.items || []
    },
    activeCommonBlocks () {
      return this.getActiveCommonBlocks?.data?.data?.items || []
    },
    getErrorForm () {
      if (window && window.b24form && window.b24form.forms) {
        window.b24form.forms = null
      }
      const url = this.isEn ? 'https://crm.tretyakov.ru/upload/crm/form/loader_156_g5sj8i.js' : 'https://crm.tretyakov.ru/upload/crm/form/loader_73_dbl7gd.js'
      return `(function(w,d,u){
		var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
		var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
	})(window,document,'${url}');`
    },
    isEnLanding () {
      return this.$route.path === '/en' || this.$route.path === '/en/'
    },
    isMobile () {
      return this.windowWidth <= this.smSize
    }
  },
  watch: {
    '$store.state.forms.idForPatronForm': function() {
      this.getMyProfileData('getIdForPatronForm', 'masterpieceForPatron')
    },
    '$store.state.forms.idForReturnPatronForm': function() {
      this.getMyProfileData('getIdForReturnPatronForm', 'masterpieceForReturnPatron')
    }
  },
  beforeMount () {
    window.addEventListener('resize', this.setResizeWindow)
    window.addEventListener('resize', () => this.$forceUpdate());
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setResizeWindow)
  },
  mounted() {
    this.setResizeWindow()

    this.$router.afterEach((to, from) => {
      window.ym(69320587, 'hit', "https://my.tretyakov.ru/app" + this.$route.fullPath)
    })

    if (this.$route.query.hasOwnProperty('openMirNextMounth')) {
      this.openMirNextMounth = true
      this.$router.push(this.$route.path)
    }
  },
  methods: {
    setResizeWindow () {
      this.windowWidth = window.innerWidth
    },
    getMounth(latter, step = 0) {
      let mounth = formatDate(new Date(), 'MMMM', step)
      if (latter) {
        if (/[йь]/.test(mounth[mounth.length - 1])) {
          mounth = mounth.slice(0, mounth.length - 1) + latter
        } else if (this.$i18n.locale !== 'en') {
          mounth += latter === 'я' ? 'а' : latter
        }
      }
      return mounth
    },
    closeErrorForm() {
      this.$store.commit('forms/closeErrorForm')
      if (window && window.b24form && window.b24form.forms) {
        window.b24form.forms = null
      }
    },
    dismissOnBoarding () {
      this.$cookies.set('boardingShown', 'true', {maxAge: 604800})
      this.showOnBoarding = false
      this.$store.commit('boardingClosed')
      if (!this.$cookies.get('acceptCookies')) {
        this.cookieVisible = true
      }
    },
    getMyProfileData(storeName, stateName) {
      const id = this.$store.getters[`forms/${storeName}`]
      if (id) {
        this.$axios({
          method: 'get',
          url: `/api/v1/gallery/getById/?id=${id}&lang=${this.$i18n.locale || 'ru'}`,
        })
          .then(({data}) => {
            this[stateName] = data.data
          })
          .catch(err => {
            console.log('ошибка загрузке шедевра для патроната', err)
          })

        this.$axios({
          method: 'get',
          url: `/api/v1/personnel/get/?lang=${this.$i18n.locale || 'ru'}`,
        })
          .then(({data}) => {
            this.myProfileData = data.data
          })
          .catch(err => {
            console.log('ошибка загрузке личных данных', err)
          })
      } else {
        this[stateName] = null
        this.myProfileData = null
      }
    }
  },
  head() {
    const image = this.getImageForShare?.data?.data || []
    const imageConfig = []
    if (image.length) {
      imageConfig.push(
        { hid: 'og:image-url', property: 'og:image:url', content: `https://my.tretyakov.ru${image[0]}` },
        { hid: 'og:image', property: 'og:image', content: `https://my.tretyakov.ru${image[0]}` }
      )
    }
    return {
      meta: [
        { hid: 'locale', property: 'og:locale', content: this.$i18n.locale || 'ru' },
        { hid: 'locale-alternate', property: 'og:locale:alternate', content: 'en_GB' },
        { hid: 'locale-alternate2', property: 'og:locale:alternate', content: 'en_US' },
        { hid: 'locale-alternate2', property: 'og:locale:alternate', content: 'ru_RU' },
        ...imageConfig
      ]
    }
  },
  chimera: {
    getImageForShare () {
      return {
        url: '/api/v1/fileFromFolder/get',
        key: `getImageForShare`,
        auto: true,
        params: {
          folder: 'fb-share-image'
        }
      }
    },
    getActiveBlocks () {
      return {
        url: `/api/activeblocks/`,
        key: `page-active-homeAuth`,
        params: {
          code: 'home-en',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getActiveCommonBlocks () {
      return {
        url: `/api/activeblocks/`,
        key: `page-active-common-homeAuth`,
        params: {
          code: 'common',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
  }
}
